import { TAddComplaintActions } from './add_complaint';
import { TGetComplaintsActions } from './get_complaints';
import { TPrefilledEmailActions, EPrefilledEmaiActionTypes } from './prefilledEmail';
import { IComplaint } from '../../api/complaint';

export interface IComplaintState {
  complaints: IComplaint[] | null;
  errorMessage: string | null;
  isComplaintAdded: boolean;
  isLoading: boolean;
  getUserFeedback: boolean;
  prefilledEmail: string | null;
}

export const complaintDefaultState: IComplaintState = {
  complaints: null,
  errorMessage: null,
  isComplaintAdded: false,
  isLoading: false,
  getUserFeedback: false,
  prefilledEmail: null,
};

export interface IComplaintStateReseted {
  type: 'IComplaintStateReseted';
}
/* istanbul ignore next */
export function resetComplaintState(): IComplaintStateReseted {
  return {
    type: 'IComplaintStateReseted',
  };
}
/* istanbul ignore next */
export function complaintReducer(
  state: IComplaintState,
  action: IComplaintStateReseted | TGetComplaintsActions | TAddComplaintActions | TPrefilledEmailActions,
): IComplaintState {
  switch (action.type) {
    case 'IComplaintStateReseted':
      return {
        ...state,
        errorMessage: null,
        isComplaintAdded: false,
        isLoading: false,
      };

    case 'IComplaintsRequested':
    case 'IAddComplaintRequested':
      return {
        ...state,
        isLoading: true,
      };

    case 'IComplaintsReceived':
      return {
        ...state,
        complaints: action.complaints,
        isLoading: false,
      };

    case 'IAddComplaintRequestFinished':
      return {
        ...state,
        isComplaintAdded: true,
        isLoading: false,
        getUserFeedback: action.getUserFeedback,
      };

    case 'IComplaintsFailed':
    case 'IAddComplaintRequestFailed':
      return {
        ...state,
        errorMessage: action.errorMessage,
        isLoading: false,
      };

    case EPrefilledEmaiActionTypes.EmailSet:
      return {
        ...state,
        prefilledEmail: action.prefilledEmail,
      };

    case EPrefilledEmaiActionTypes.EmailReset:
      return {
        ...state,
        prefilledEmail: null,
      };

    default:
      return state || complaintDefaultState;
  }
}
